import * as Popover from "@radix-ui/react-popover";
import React, { useState } from "react";

type ContextMenuProps = {
  isSelected: boolean;
  onClose: () => void;
  onDuplicate: () => void;
  allowDuplicate: boolean;
  popupContainerRef?: React.RefObject<HTMLDivElement>;
};

export const ContextMenu = ({
  isSelected,
  onClose,
  onDuplicate,
  allowDuplicate,
}: ContextMenuProps) => {
  const [open, setOpen] = useState(false);

  const handleItemClick = (action: () => void) => {
    setOpen(false);
    action();
  };

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <div
          className={`flex items-center absolute top-[6px] right-[8px] p-[2px] cursor-pointer ${isSelected ? "opacity-100" : "group-hover:opacity-100 opacity-0 transition-opacity"}`}
          onClick={(e) => e.stopPropagation()}
        >
          <i className="fa-regular fa-ellipsis-vertical text-[14px] text-neutral-500" />
        </div>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          sideOffset={8}
          className="bg-white rounded-[8px] shadow-lg border-neutral-100 border-[1px] w-[200px] py-[4px] outline-none"
          align="start"
          side="right"
          onClick={(e) => e.stopPropagation()}
        >
          <Item onClick={() => handleItemClick(onClose)}>
            <i className="fa-regular fa-close text-[16px]" />
            Close
          </Item>
          {allowDuplicate && (
            <Item onClick={() => handleItemClick(onDuplicate)}>
              <i className="fa-regular fa-clone text-[16px]" />
              Duplicate
            </Item>
          )}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

const Item = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick: () => void;
}) => {
  return (
    <div
      className="flex px-[14px] py-[8px] hover:bg-primary-25 gap-[8px] items-center text-[14px] cursor-default"
      onClick={onClick}
    >
      {children}
    </div>
  );
};
